<!-- Main Page Start -->
<section class="skillsWrap projects">
    <div class="left-sidebar">
        <app-sidebar></app-sidebar>
    </div>
    <div class="right-panel">

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="topHeader">
                <h2 class="pageTitle">Job Preferences </h2>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <div class="form-group">
                        <label>Preferred industry <span class="orangeText">*</span></label>
                        <div class="search">
                            <!--  select -->
                            <!-- <input type="text" class="form-control select" placeholder="Enter" [(ngModel)]="userQuestion" name="userQuestion" id="userQuestions" (ngModelChange)="search()" formControlName="industrySearch" autocomplete="off"/>
                            <ul class="dropdown" *ngIf="show">
                                <li *ngFor="let indus of allIndustry;let i=index;" (click)="selectedSkill(i);drop()">
                                  <a href="javascript:void(0)">{{indus.name}}</a> 
                                  </li> 
                            </ul> --> 
                            <ng-multiselect-dropdown  formControlName="industryIds" class="form-control noBorder px-0" [placeholder]="'Select'" [settings]="dropdownSettingsIndustry" [data]="allIndustry"(onDeSelect)="onItemDeSelect($event)"
                           (onDeSelectAll)="onDeSelectAll($event)" ></ng-multiselect-dropdown>
                        </div>
                        <div class="text-danger" *ngIf="form.controls['industryIds'].hasError('required') && showError">
                            *Please enter Preferred industry.
                        </div>
                        <!-- <ul class="addedskills mt-3">
                            <li  *ngFor="let indus of addedIndus; let i=index;"> {{indus.name}} <a href="javascript:void(0);" (click)="removeSkills(i)"> × </a> </li> 
                        </ul> -->
                    </div>
                    <div class="form-group">
                        <label>Select category <span class="orangeText">*</span></label>
                        <select class="form-control" formControlName="categoryId" (change)="selectCategoryId($event)">
                            <option disabled selected>Select</option>
                            <option *ngFor="let cat of allCat;let i=index" [value]="cat.id">{{cat.name}}</option>
                        </select>
                        <div class="text-danger" *ngIf="form.controls['categoryId'].hasError('required') && showError">
                            *Please select category.
                        </div> 
                    </div>
                    
                    <div class="form-group" *ngIf="subCat">
                        <label>Sub Category </label> 
                        <ng-multiselect-dropdown  formControlName="subCategoryId" class="form-control noBorder px-0 subCatMulti" [placeholder]="'Select'" [settings]="dropdownSettings" [data]="allSubCat" [ngClass]="allSubCat.length == 0 ?'disabled':''"></ng-multiselect-dropdown>
                        <div class="text-danger" *ngIf="form.controls['subCategoryId'].hasError('required') && showError">
                            *Please select sub category.
                        </div> 
                    </div>
                    <div class="form-group">
                        <label>Preferred Job title <span class="orangeText">*</span></label>
                        <div class="search">
                            <!-- <input type="text" class="form-control select" placeholder="Enter" [(ngModel)]="jobQues" name="jobQues" id="jobQues" (ngModelChange)="searchJob()"  formControlName="jobTitleSearch" autocomplete="off"/>
                            <ul class="dropdown" *ngIf="showJob">
                                <li *ngFor="let job of allJobtitle;let i=index;" (click)="selectedJobs(i);dropJob()">
                                  <a href="javascript:void(0)">{{job.name}}</a> 
                                  </li> 
                            </ul> -->
                            <ng-multiselect-dropdown  formControlName="jobTitleIds" class="form-control noBorder px-0" [placeholder]="'Select'" [settings]="dropdownSettingJobTitle" [data]="allJobtitle" ></ng-multiselect-dropdown>
                        </div>
                        <div class="text-danger" *ngIf="form.controls['jobTitleIds'].hasError('required') && showError">
                            *Please enter Preferred job title.
                        </div>
                        <div class="text-danger" *ngIf="form.value.jobTitleIds?.length>50 && !form.controls['jobTitleIds'].hasError('required')">
                            *You can add up to 50 Preferred job title. Please remove additional Preferred job title.
                        </div>
                        <!-- <ul class="addedskills mt-3">
                            <li  *ngFor="let job of addedJobs; let i=index;"  [ngClass]="job.selected == true ? 'selected' : ''"> {{job.name}} <a href="javascript:void(0);" (click)="removeJob(i)"> × </a> </li> 
                        </ul> -->
                    </div>
                </div> 
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Service</label>
                        <select id="state" class="form-control" name="serviceId" formControlName="serviceId"  (ngModelChange)="selectedService($event)">
                            <option *ngFor="let data of serviceList;let i=index;" [value]="data.id">{{data.name}}</option>
                        </select>
                        <div class="text-danger" *ngIf="form.controls['serviceId'].hasError('required') && showError">
                            *Please enter service.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Date of availability</label>
                        <div id="date-picker-example" class="datepicker">
                            <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="form.value.dateOfAvailability" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"  [minDate]="minDate" formControlName="dateOfAvailability" (keydown)="onKeyDown($event)">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger" *ngIf="showError == true && form.controls['dateOfAvailability'].hasError('required')">*Please select From</div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12" *ngIf="showOtherService">
                    <div class="form-group">
                        <label>Other Service Title<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Other Service Title " formControlName="otherServiceTitle"/> 
                        <div class="text-danger" *ngIf="showOtherService && form.controls['dateOfAvailability'].hasError('otherServiceTitle') && showError">
                          *Please enter Other Service Title.
                        </div> 
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">

                    <div class="form-group">
                        <label>Desired Salary </label>
                        <div class=" d-flex justify-content-between salaryDiv">
                            <input type="text" class="form-control" placeholder="USD" value="USD" readonly>
                            <input type="text" class="form-control" placeholder="Enter" formControlName="desiredSalary"  (keypress)="preventNumbers($event)" maxlength="10">
                            <select class="form-control" formControlName="desiredSalaryType"  [(ngModel)]="salaryType">
                                <option disabled selected value="Salary Type">Salary Type</option>
                                <option value="Per Hour">Per Hour</option>
                                <option value="Per Day">Per Day</option>
                                <option value="Per Week">Per Week</option>
                                <option value="Per Month">Per Month</option>
                                <option value="Per Annum">Per Annum</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <h6 class="pageTitle subTitle2">Tour of Duty
                        <a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn" (click)="openTourDuty(addTourDuty)"> <i class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add more</a>
                    </h6>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6"  *ngFor="let tour of form.value.tourOfDuties;let i=index;">
                    <div class="joinservice">
                        <div class="textinner">{{tour.location}}
                            <p class="para3">Served from : {{tour.fromDate | date}} - {{tour.toDate |date}}</p>
                        </div>
                        <div>
                            <a href="javascript:void(0)" (click)="editTour(i,addTourDuty)"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                            <a href="javascript:void(0)" (click)="deleteTour(i)"><img src="assets/images/ic_delete.svg" class="ht"></a>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="row  ptb">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <h6 class="pageTitle subTitle2"><label>Preferred Job Location<span class="orangeText">*</span> </label>
                        <a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn" (click)="openPreferredLocation(addJobs)"> <i class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add more</a>
                    </h6>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6" *ngFor="let loc of form.value.locations;let i=index;">
                    <div class="joinservice"> {{loc.location}}
                        <div>
                            <a href="javascript:void(0)" (click)="editMember(i,addJobs)"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                            <a href="javascript:void(0)" (click)="deleteMember(i)"><img src="assets/images/ic_delete.svg" class="ht"></a>
                        </div>
                    </div>
                </div>
                <div class="text-danger" *ngIf="form.controls['locations'].hasError('required') && showError">
                *Please add preferred job location</div>
            </div>
            <div class="row">
                
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="form-group">
                        <label>Work Authorization <span class="orangeText">*</span> </label>
                        <select class="form-control" formControlName="workAuthorization">
                            <!-- <option value="0">No</option> -->
                            <option value="1">Green card</option>
                            <option value="2">EAD</option>
                            <option value="3">H1B Visa</option>
                            <option value="4">Citizen</option>
                        </select>
                        <div class="text-danger" *ngIf="form.controls['workAuthorization'].hasError('required') && showError">
                            *Please select work authorization.
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle">Employment type</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let emp of allEmployee;let i=index;" (click)="selectedEmploymentType(i,$event)" [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle">Travel requirements</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let trav of allTravel;let i=index;" (click)="selectedTravel(i,$event)" [ngClass]="trav.selected == true ? 'selected' : ''">{{trav.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle">Work Place</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let emp of workPlaceList;let i=index;" (click)="selectedworkPlaceList(i,$event)"
                                [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li>
                        </ul>
                        <!-- <ul class="suggestedskills radioBox_set">
                            <li>
                                <label class="radioSwitch-label" for="workType"> <input type="radio" id="workType" [value]="'Remote'" formControlName="workPlace" name="workPlace" (change)="form.value.workPlace='Remote'" [checked]="form.value.workPlace=='Remote'"><i class="input-helper"></i><span>Remote</span> </label>
                            </li>
                            <li>
                                <label class="radioSwitch-label" for="workType">
                                    <input type="radio" id="workType" [value]="'Onsite'" formControlName="workPlace" name="workPlace" (change)="form.value.workPlace='Onsite'" [checked]="form.value.workPlace=='Onsite'"><i class="input-helper"></i><span>Onsite</span></label>
                            </li>
                            <li>
                                <label class="radioSwitch-label" for="workType">
                                    <input type="radio" id="workType" [value]="'Hybrid'" formControlName="workPlace" name="workPlace" (change)="form.value.workPlace='Hybrid'" [checked]="form.value.workPlace=='Hybrid'"><i class="input-helper"></i><span>Hybrid</span></label>
                            </li>
                        </ul> -->
                    </div>
                </div>

               

                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle">Security clearance</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let sec of allSecurity;let i=index;" (click)="selectedSecurity(i,$event)" [ngClass]="sec.selected == true ? 'selected' : ''">{{sec.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>Are you willing to relocate ?</label>
                        <div class="d-flex spaceRight radioWrap">
                            <input type="radio" id="yes"  [value]="1" formControlName="willingToRelocate" >
                            <label for="yes"> Yes </label>
                            <input type="radio" id="no"  [value]="0" formControlName="willingToRelocate">
                            <label for="no"> No </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>Are you covid-19 vaccinated ?</label>
                        <div class="d-flex spaceRight radioWrap">
                            <input type="radio" id="yes1"  [value]="1" formControlName="covidVaccinated" >
                            <label for="yes1"> Yes </label>
                            <input type="radio" id="no1"  [value]="0" formControlName="covidVaccinated">
                            <label for="no1"> No </label>
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-12 co-sm-12 col-lg-12">
                    <input type="submit" value="Continue to preview"  class="commonBtn width50 mt-2"> 
                </div>
            </div>
        </form>
    </div>
</section>


<!-- Modals  -->
<ng-template #addTourDuty>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="this.modalRef?.hide()"><span aria-hidden="true">&times;</span></button>
        <form [formGroup]="addTour" (ngSubmit)="onTourDuty()">
            <h4 class="pageTitle mb-3"> Tour of Duty</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Location<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Enter location" formControlName="location">
                        <div class="text-danger" *ngIf="showError == true && addTour.controls['location'].hasError('required')">*Please enter location</div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Zip Code<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Enter zip code" formControlName="zipCode" (keypress)="preventNumbers($event)" maxlength="6" >
                        <div class="text-danger" *ngIf="showError == true && addTour.controls['zipCode'].hasError('required')">*Please enter zip code</div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label> From </label>
                        <div id="date-picker-example" class="datepicker">
                            <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="addTour.value.fromDate" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="fromDate" [maxDate]="maxDate">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger" *ngIf="showError == true && addTour.controls['fromDate'].hasError('required')">*Please select From date</div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label> To </label>
                        <div id="date-picker-example" class="datepicker">
                            <input type="text" placeholder="Enter date" class="form-control" bsDatepicker [minDate]="addTour.value.fromDate == '' ? minDate : addTour.value.fromDate" formControlName="toDate" [bsValue]="addTour.value.toDate" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger" *ngIf="showError == true && addTour.controls['toDate'].hasError('required')">*Please select To date</div>
                    </div>
                </div>
            </div>
            <div class="form-group mt-2">
                    <input type="submit" class="commonBtn width50" value="Save"/>
            </div>
        </form>
    </div>
</ng-template>
<!-- Modals  -->
<ng-template #addJobs>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="this.modalRef?.hide()"><span aria-hidden="true">&times;</span></button>
        <form [formGroup]="addJob" (ngSubmit)="onAddJobs()">
            <h4 class="pageTitle mb-3">{{title}} Preferred Job Location</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Location<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Enter location" formControlName="location">
                        <!-- <div class="text-danger" *ngIf="addJob.controls['location'].hasError('required') && showLocationError">
                            *Please enter location.
                        </div> -->
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Zip Code<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Enter zip code" formControlName="zipCode" (keypress)="preventNumbers($event)" maxlength="6">
                        <div class="text-danger" *ngIf="addJob.controls['zipCode'].hasError('required') && showZipError">
                            *Please enter zip code.
                        </div>
                        <div class="text-danger" *ngIf="showLocationError">
                            *Please enter valid zipcode.
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group mt-2">
                <input type="submit" class="commonBtn width50" value="Save">
            </div>
        </form>
    </div>
</ng-template>